export default __webpack_public_path__ + "static/media/anthem-website-logos_adcouncil.37226eb2.webp";